const IMG_BB_API_KEYS = [
  "4b8d7989751c89d9561fd1e44100bf68",
  "2c5257b8de4e5bf05fc5a7b2419a418e",
  "62346dd09fb59412e2774c150742d3a4",
];

export const uploadToImgBB = async (file) => {
  const base64 = await toBase64(file);

  for (let key of IMG_BB_API_KEYS) {
    try {
      const formData = new FormData();
      formData.append("image", base64.split(",")[1]);

      const res = await fetch(
        `https://api.imgbb.com/1/upload?key=${key}`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await res.json();

      if (data.success) {
        return data.data.url;
      }
    } catch (e) {
      console.log("ImgBB key failed, trying next...");
    }
  }

  throw new Error("All ImgBB keys failed");
};

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
